<div class="assinatura" *ngIf="show">
  <div class="modal-body">
    <div class="row">
      <div class="col-md-12 text-center">
        <h4>Valores para você melhorar seu gerenciamento e desempenho</h4>
        <p>Assine e ganhe 10 dias de testes sem nenhuma cobrança</p>
      </div>
    </div>
    <div class="row mt-4">
      <div class=" ml-auto pricing-box align-self-center"
           [ngClass]="{'col-md-4': planos.length == 3, 'col-md-6': planos.length == 2, 'col-md-3': planos.length > 3, 'col-md-12': planos.length > 1}"
           *ngFor="let plano of planos">
        <div class="ml-auto pricing-box align-self-center">
          <div class="card mb-4">
            <div class="card-body p-4 text-center">
              <h5 class="font-weight-normal">{{plano.nome}}</h5>
              <sup>R$</sup><span class="text-dark display-5">{{plano.preco}}</span>
              <h6 class="font-weight-light font-14">por mês</h6>
              <p class="mt-4">{{plano.descricao}}</p>
            </div>
            <a class="btn btn-primary p-3 btn-block border-0 text-white" (click)="assinarPlano(plano.id)">Escolha seu plano</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
